import type { StandingOrders } from './StandingOrders';

export const HU: Partial<StandingOrders> = {
    createSweepOrders: false,
    standingOrderIntervals: ['DAILY', 'WEEKLY', 'MONTHLY', 'QUARTERLY', 'HALFYEARLY', 'YEARLY'],
    fetchReceiver: true,
    daysFromTodayOutsideRange: 1,
    executionModes: [
        'UNTIL_CANCELLATION',
        'UNTIL_DATE',
        'AFTER_MAX_ITERATION_EXCEEDED',
        'AFTER_MAX_AMOUNT_EXCEEDED',
    ],
    executionModesSweep: [
        'UNTIL_CANCELLATION',
        'UNTIL_DATE',
        'AFTER_MAX_ITERATION_EXCEEDED',
        'AFTER_MAX_AMOUNT_EXCEEDED',
    ],
    daysUntilLastOfMonth: 100,
    disableExecutionIntervalSelectOnEdit: true,
};
